import React, { } from 'react';
import { FaHome, FaRegAddressBook, FaLandmark } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { useAuth } from '../http/authcontex';
import './common.css';
import './style.css';
import { FaHouseLock } from 'react-icons/fa6';

export default function SideNave({ isSidebarOpen }) {
    const { userEmail } = useAuth();
    //const { userRoles } = useAuth();

    return (
        <div className={`SideNave ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading">Core</div>
                                <Link className="nav-link" to="/dashboard">
                                    <div className="sb-nav-link-icon"><FaHome /></div>
                                    Dashboard
                                </Link>
                                {/*<div className="sb-sidenav-menu-heading">Activity</div>
                                userRoles.includes("ADMIN") && (
                                    <>
                                        <Link className="nav-link" to="/user">
                                        <div className="sb-nav-link-icon"><FaUserEdit /></div>
                                        Users
                                        </Link>
                                        <Link className="nav-link" to="/project">
                                        <div className="sb-nav-link-icon"><FaFileSignature /></div>
                                        Projects
                                        </Link>
                                    </>
                                    )}*/}
                                     
                                    <div className="sb-sidenav-menu-heading">Activity</div>
                                        <Link className="nav-link" to="/sarfaesi">
                                        <div className="sb-nav-link-icon"><FaHouseLock /></div>
                                            Sarfaesi
                                        </Link>
                                        <Link className="nav-link" to="/bank">
                                            <div className="sb-nav-link-icon"><FaLandmark /></div>
                                            Bank
                                        </Link>
                                        <Link className="nav-link" to="/report">
                                            <div className="sb-nav-link-icon"><FaRegAddressBook /></div>
                                            Report
                                        </Link>

                                        {/*
                                        <div className="sb-sidenav-menu-heading">Masters</div>
                                        <Link className="nav-link" to="/bank">
                                            <div className="sb-nav-link-icon"><FaLandmark /></div>
                                            Bank
                                        </Link>
                                        */}

                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">Logged in as:</div>
                            {userEmail || 'Unknown'}
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
}
